import { Component, createElement } from 'react';
import { formatDepositRenderError } from './redact.js';
import { phrase } from '../i18n/language.js';

export function DepositErrorFallback({
  title = 'Deposit UI Error',
  message,
  componentStack,
  appFrames,
}) {
  return createElement(
    'div',
    { className: 'section-card deposit-ui-error', role: 'alert', 'data-testid': 'deposit-ui-error' },
    createElement('div', { className: 'contact-block-title' }, phrase(title)),
    createElement('pre', { className: 'deposit-ui-error-msg' }, phrase(message || 'Unknown error')),
    componentStack
      ? createElement('pre', { className: 'deposit-ui-error-stack' }, componentStack)
      : null,
    appFrames && appFrames.length
      ? createElement('pre', { className: 'deposit-ui-error-stack' }, appFrames.join('\n'))
      : null
  );
}

export class DepositErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, diagnostic: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, diagnostic: formatDepositRenderError(error, null) };
  }

  componentDidCatch(error, errorInfo) {
    const diagnostic = formatDepositRenderError(error, errorInfo);
    this.setState({ hasError: true, diagnostic });
    try {
      console.error(this.props.logTag || '[DEPOSIT_RENDER_ERROR]', diagnostic.message, diagnostic.componentStack);
    } catch {
      /* ignore */
    }
  }

  render() {
    if (this.state.hasError) {
      const d = this.state.diagnostic || {};
      return createElement(DepositErrorFallback, {
        title: this.props.title || 'Deposit UI Error',
        message: d.message,
        componentStack: d.componentStack,
        appFrames: d.appFrames,
      });
    }
    return this.props.children;
  }
}

/** Test-only child. Not imported by production overlay. */
export function DepositForceErrorChild() {
  throw new Error('forced deposit test error');
}
